import { BoxMode, type BoxInfo } from '@lub0v/santa-utils';

export const RECENT_GAME_WINDOW_MS = 15 * 60 * 1000;

export function newestRecentGame(games: BoxInfo[], now = Date.now()): BoxInfo | undefined {
  return games.filter(game => game.isAdmin && !game.box.isArchived && game.box.mode !== BoxMode.QUICK &&
    typeof game.createdAt === 'number' && Number.isFinite(game.createdAt) &&
    game.createdAt <= now && now - game.createdAt < RECENT_GAME_WINDOW_MS)
    .sort((a, b) => b.createdAt! - a.createdAt!)[0];
}
